const mutations = {
    //切换登录弹框的显示与隐藏
    changeShowLoginDialogState(state){
        state.isShowLoginDialog = !state.isShowLoginDialog;
    },
    setKeyWord(state) {
        var path = window.location.href.toLocaleLowerCase();
        var path_arr = path.split("/");
        path_arr.forEach(function (item) {
            if(item.indexOf("sou") > -1){
                state.keyWord = decodeURIComponent(item.replace("sou", ""));
            }
        });
    },
};
export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js